import React from "react";
import { VOSViewModel } from "../../models/viewModel";
import { useAppSelector, VRIAppStateType } from "../../core";
import { timeZones } from "../../features/modals/jobFormData";
import { dateFormatInUSA } from "../../utils";
import { ApplicationName } from "../../configs";

export function PageVOSPRint({ data }: { data: VOSViewModel }): JSX.Element {
  const { profile } = useAppSelector((state:VRIAppStateType) => state.auth);
  return (
    <>
      <div id="rootPrintElement">
        <table
          style={{
            width: "277mm",
            borderCollapse: "collapse",
            tableLayout: "fixed",
            margin: "0 auto",
          }}
        >
          <tbody>
            <tr style={{ width: "100%" }}>
              <td style={{ width: "100%" }}>
                <table
                  style={{
                    borderRadius: "1.2mm",
                    border: "0.75pt solid #ccc",
                    width: "100%",
                  }}
                >
                  <tbody>
                    <tr>
                      <td>
                        <table
                          style={{
                            textAlign: "center",
                            margin: "auto",
                            borderCollapse: "collapse",
                          }}
                        >
                          <tbody>
                            <td
                              style={{
                                paddingLeft: "15mm",
                                paddingTop: "3mm",
                                paddingBottom: "2mm",
                                backgroundImage: "url(data:image/svg+xml;base64,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)"
                              }}
                            >
                            </td>
                            <td
                              style={{
                                paddingTop: "2mm",
                                paddingBottom: "3mm",
                              }}
                            >
                              <table
                                style={{
                                  border: "none",
                                  textAlign: "left",
                                  marginLeft: "7mm",
                                }}
                              >
                                <tr>
                                  <td style={{ whiteSpace: "normal" }}>
                                    {" "}
                                    Address: 32910 W. Thirteen Mile Road , Suite E-504, Farmington Hills, MI 48334, USA
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ whiteSpace: "normal" }}>
                                    {" "}
                                    Phone: (313) 871-0080 Ext. 1, Fax: (888)
                                    225-1912
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ whiteSpace: "normal" }}>
                                    {" "}
                                    Website: www.brombergtranslations.com
                                  </td>
                                </tr>
                                <tr>
                                  <td style={{ whiteSpace: "normal" }}>
                                    {" "}
                                    Email:
                                    {/* <a href=""> */}
                                      {" "}
                                      Scheduler@BrombergTranslations.com
                                    {/* </a> */}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  fontSize: "1.5em",
                  paddingTop: "1em",
                  paddingBottom: "0.5em",
                }}
              >
                INTERPRETER ASSIGNMENT STATEMENT
              </td>
            </tr>
            <tr>
              <td>
                <table
                  style={{
                    border: "0.75pt solid #ccc",
                    borderRadius: "5mm",
                    width: "100%",
                  }}
                >
                  <tbody>
                    <tr style={{ width: "100%" }}>
                      <td>
                        <table
                          style={{
                            borderCollapse: "collapse",
                            borderSpacing: "0",
                          }}
                        >
                          <thead>
                            <tr style={{ borderBottom: "0.75pt solid #ccc" }}>
                              <th
                                style={{
                                  textAlign: "left",
                                  padding: "0.6em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "600" }}>
                                  Interpreter:{" "}
                                </span>{" "}
                                <span style={{ fontWeight: "400" }}>
                                  {data.Interpreter}
                                </span>
                              </th>
                              <th
                                style={{
                                  textAlign: "left",
                                  padding: "0.6em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                  borderRight: "1px solid #ccc",
                                }}
                              >
                                <span style={{ fontWeight: "600" }}>
                                  Language:{" "}
                                </span>{" "}
                                <span style={{ fontWeight: "400" }}>
                                  {data.Language}
                                </span>
                              </th>
                              <th
                                style={{
                                  textAlign: "left",
                                  padding: "0.6em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "600" }}>
                                  Date:{" "}
                                </span>{" "}
                                <span style={{ fontWeight: "400" }}>
                                  {data.Date ? dateFormatInUSA(data.Date) : "-"}
                                </span>
                              </th>
                              <th
                                style={{
                                  textAlign: "left",
                                  padding: "0.6em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "600" }}>
                                  Job ID#:{" "}
                                </span>{" "}
                                <span style={{ fontWeight: "400" }}>
                                  {data.JobID}
                                </span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.7em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "600" }}>
                                  Customer:
                                </span>
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.6em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                  borderRight: "0.75pt solid #ccc",
                                }}
                              >
                                <span style={{ fontWeight: "400" }}>
                                  {data.Customer}
                                </span>
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.7em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "600" }}>
                                  Requested Start Time:
                                </span>
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.7em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "400" }}>
                                  {data.RequestedStartTime} {data.timeZone ? timeZones.find(
                                    (x) => x.value === data.timeZone
                                  )?.label : ""}
                                  {/* {profile?.timeZone
                                    ? timeZones.find(
                                      (x) => x.value === profile?.timeZone
                                    )?.label
                                    : "N/A"} */}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.7em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "600" }}>
                                  Location:
                                </span>
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.6em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                  borderRight: "0.75pt solid #ccc",
                                }}
                              >
                                <span style={{ fontWeight: "400" }}>
                                  {data.Location}
                                </span>
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.7em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "600" }}>
                                  Actual Start Time:
                                </span>
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.7em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "400" }}>
                                  {data.ActualStartTime
                                    ? data.ActualStartTime
                                    : "- - - - - - - - - -"}{profile?.timeZone && data.ActualStartTime
                                      ? timeZones.find(
                                        (x) => x.value === profile?.timeZone
                                      )?.label
                                      : null}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.7em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "600" }}>
                                  Contact Info:
                                </span>
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.6em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                  borderRight: "0.75pt solid #ccc",
                                }}
                              >
                                <span style={{ fontWeight: "400" }}>
                                  {data.ContactInfo}
                                </span>
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.7em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "600" }}>
                                  Actual End Time:
                                </span>
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.7em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "400" }}>
                                  {data.ActualEndTime
                                    ? data.ActualEndTime
                                    : "- - - - - - - - - -"}{profile?.timeZone && data.ActualEndTime
                                      ? timeZones.find(
                                        (x) => x.value === profile?.timeZone
                                      )?.label
                                      : ""}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.7em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "600" }}>
                                  File Number/Details:
                                </span>
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.6em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                  borderRight: "0.75pt solid #ccc",
                                }}
                              >
                                <span style={{ fontWeight: "400" }}>
                                  {data.FileNumber}
                                </span>
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.7em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "600" }}>
                                  Mileage:
                                </span>
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.7em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "400" }}>
                                  {data.Mileage
                                    ? data.Mileage
                                    : "- - - - - - - - - -"}
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.7em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.6em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                  borderRight: "0.75pt solid #ccc",
                                }}
                              ></td>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.7em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "600" }}>
                                  Consumer:
                                </span>
                              </td>
                              <td
                                style={{
                                  textAlign: "left",
                                  padding: "0.7em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "400" }}>
                                  {data.Consumer}
                                </span>
                              </td>
                            </tr>
                            <tr style={{ borderTop: "0.75pt solid #ccc" }}>
                              <td
                                colSpan={2}
                                style={{
                                  textAlign: "left",
                                  padding: "0.7em 0.5em",
                                  borderRight: "0.75pt solid #ccc",
                                }}
                              >
                                <span style={{ fontWeight: "600" }}>
                                  If you are requested to stay longer than the
                                  assignment schedule time, please contact us
                                  immediately at (313)871-0080 Ext. 1 during
                                  business hours or (313)878-4242 after
                                </span>
                              </td>
                              <td
                                colSpan={2}
                                style={{
                                  textAlign: "left",
                                  padding: "0.7em 0.5em",
                                  width: "25%",
                                  verticalAlign: "text-top",
                                }}
                              >
                                <span style={{ fontWeight: "600" }}>
                                  If The consumer or client do not arrive within
                                  30 minutes of the start time, please contact
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  paddingTop: "0.9em",
                  paddingBottom: "0.9em",
                  borderBottom: "0.75pt solid #ccc",
                }}
              >
                <span style={{ fontWeight: "600" }}>Note:</span>
                <span>
                  {" "}
                  It is the responsibility of the Interpreter to complete the
                  assignment successfully, on time, with the highest quality
                  results and according to the client’s specifications.
                </span>
              </td>
            </tr>
            <tr>
              <td
                style={{
                  fontWeight: "600",
                  paddingTop: "1.25em",
                  paddingBottom: "0.7em",
                }}
              >
                QUESTIONNAIRE (FILLING THIS SHORT FORM OUT HELPS US TO UPHOLD
                THE HIGH STANDARDS OF INTERPRETING)
              </td>
            </tr>
            <tr>
              <td>
                <table
                  style={{
                    border: "0.75pt solid #ccc",
                    borderTopLeftRadius: "5mm",
                    borderRadius: "5mm",
                    textAlign: "left",
                    width: "100%",
                  }}
                >
                  <tr>
                    <td
                      style={{
                        textAlign: "left",
                        padding: "0.7em 0.7em",
                        borderBottom: "0.75pt solid #ccc",
                        fontWeight: "600",
                      }}
                    >
                      Please Indicate what level you agree or disagree with each
                      statement below
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <table
                        style={{
                          width: "100%",
                          borderBottom: "0.75pt solid #ccc",
                        }}
                      >
                        <thead>
                          <tr>
                            <td
                              style={{
                                textAlign: "center",
                                padding: "0.5em 0.5em",
                              }}
                            >
                              1. The Interpreter conducted himself/herself in a
                              professional demeanor (punctuality, professional
                              appearance, etc.)
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                textAlign: "center",
                                padding: "0.5em 0.5em",
                              }}
                            >
                              <span style={{ margin: "2mm" }}>
                                Strongly Disagree
                              </span>
                              <span style={{ margin: "2mm" }}>
                                <input
                                  style={{
                                    backgroundColor: "red",
                                    boxShadow:
                                      "inset 0 0 0 0.1em #fff, 0 0 0 0.1em red",
                                  }}
                                  defaultChecked={
                                    data.Questionnaire1 == "a1" ? true : false
                                  }
                                  className="medium"
                                  type="radio"
                                  id="a1"
                                  name="a"
                                  value="a1"
                                />
                                <input
                                  className="medium"
                                  defaultChecked={
                                    data.Questionnaire1 == "a2" ? true : false
                                  }
                                  type="radio"
                                  id="a2"
                                  name="a"
                                  value="a2"
                                />
                                <input
                                  defaultChecked={
                                    data.Questionnaire1 == "a3" ? true : false
                                  }
                                  className="medium"
                                  type="radio"
                                  id="a3"
                                  name="a"
                                  value="a3"
                                />
                                <input
                                  defaultChecked={
                                    data.Questionnaire1 == "a4" ? true : false
                                  }
                                  className="medium"
                                  type="radio"
                                  id="a4"
                                  name="a"
                                  value="a4"
                                />
                                <input
                                  defaultChecked={
                                    data.Questionnaire1 == "a5" ? true : false
                                  }
                                  className="medium"
                                  type="radio"
                                  id="a5"
                                  name="a"
                                  value="a5"
                                />
                              </span>
                              <span style={{ margin: "2mm" }}>
                                Strongly Agree
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        style={{
                          width: "100%",
                          borderBottom: "0.75pt solid #ccc",
                        }}
                      >
                        <thead>
                          <tr>
                            <td
                              style={{
                                textAlign: "center",
                                padding: "0.5em 0.5em",
                              }}
                            >
                              2. The Interpreter was familiar with the
                              appropriate terminology and procedures (legal,
                              medical, business, etc.)
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                textAlign: "center",
                                padding: "0.5em 0.5em",
                              }}
                            >
                              <span style={{ margin: "2mm" }}>
                                Strongly Disagree
                              </span>
                              <span style={{ margin: "2mm" }}>
                                <input
                                  defaultChecked={
                                    data.Questionnaire2 == "b1" ? true : false
                                  }
                                  className="medium"
                                  type="radio"
                                  id="b1"
                                  name="b"
                                  value="b1"
                                />
                                <input
                                  defaultChecked={
                                    data.Questionnaire2 == "b2" ? true : false
                                  }
                                  className="medium"
                                  type="radio"
                                  id="b2"
                                  name="b"
                                  value="b2"
                                />
                                <input
                                  defaultChecked={
                                    data.Questionnaire2 == "b3" ? true : false
                                  }
                                  className="medium"
                                  type="radio"
                                  id="b3"
                                  name="b"
                                  value="b3"
                                />
                                <input
                                  defaultChecked={
                                    data.Questionnaire2 == "b4" ? true : false
                                  }
                                  className="medium"
                                  type="radio"
                                  id="b4"
                                  name="b"
                                  value="b4"
                                />
                                <input
                                  defaultChecked={
                                    data.Questionnaire2 == "b5" ? true : false
                                  }
                                  className="medium"
                                  type="radio"
                                  id="b5"
                                  name="b"
                                  value="b5"
                                />
                              </span>
                              <span style={{ margin: "2mm" }}>
                                Strongly Agree
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table
                        style={{
                          width: "100%",
                          borderBottom: "0.75pt solid #ccc",
                        }}
                      >
                        <thead>
                          <tr>
                            <td
                              style={{
                                textAlign: "center",
                                padding: "0.5em 0.5em",
                              }}
                            >
                              3. The Interpreter adhered to the professional
                              code of ethics by refraining from conseving with
                              parties, interpretingfully for both parties,
                              appearing neutral, representing his /her
                              qualifications
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                textAlign: "center",
                                padding: "0.5em 0.5em",
                              }}
                            >
                              <span style={{ margin: "2mm" }}>
                                Strongly Disagree
                              </span>
                              <span style={{ margin: "2mm" }}>
                                <input
                                  defaultChecked={data.Questionnaire3 == "c1"}
                                  className="medium"
                                  type="radio"
                                  id="c1"
                                  name="c"
                                  value="c1"
                                  onChange={() => { }}
                                />
                                <input
                                  defaultChecked={data.Questionnaire3 == "c2"}
                                  type="radio"
                                  id="c2"
                                  name="c"
                                  value="c2"
                                  onChange={() => { }}
                                />
                                <input
                                  defaultChecked={data.Questionnaire3 == "c3"}
                                  className="medium"
                                  type="radio"
                                  id="c3"
                                  name="c"
                                  value="c3"
                                  onChange={() => { }}
                                />
                                <input
                                  defaultChecked={data.Questionnaire3 == "c4"}
                                  className="medium"
                                  type="radio"
                                  id="c4"
                                  name="c"
                                  value="c4"
                                  onChange={() => { }}
                                />
                                <input
                                  defaultChecked={data.Questionnaire3 == "c5"}
                                  className="medium"
                                  type="radio"
                                  id="c5"
                                  name="c"
                                  value="c5"
                                  onChange={() => { }}
                                />
                              </span>
                              <span style={{ margin: "2mm" }}>
                                Strongly Agree
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <table style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <td
                              style={{
                                textAlign: "center",
                                padding: "0.5em 0.5em",
                              }}
                            >
                              4. I would like to work with this interpreter
                              again
                            </td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td
                              style={{
                                textAlign: "center",
                                padding: "0.5em 0.5em",
                              }}
                            >
                              <span style={{ margin: "2mm" }}>
                                Strongly Disagree
                              </span>
                              <span style={{ margin: "2mm" }}>
                                <input
                                  defaultChecked={
                                    data.Questionnaire4 == "d1" ? true : false
                                  }
                                  className="medium"
                                  type="radio"
                                  id="d1"
                                  name="d"
                                  value="d1"
                                />
                                <input
                                  defaultChecked={
                                    data.Questionnaire4 == "d2" ? true : false
                                  }
                                  className="medium"
                                  type="radio"
                                  id="d2"
                                  name="d"
                                  value="d2"
                                />
                                <input
                                  defaultChecked={
                                    data.Questionnaire4 == "d3" ? true : false
                                  }
                                  className="medium"
                                  type="radio"
                                  id="d3"
                                  name="d"
                                  value="d3"
                                />
                                <input
                                  defaultChecked={
                                    data.Questionnaire4 == "d4" ? true : false
                                  }
                                  className="medium"
                                  type="radio"
                                  id="d4"
                                  name="d"
                                  value="d4"
                                />
                                <input
                                  defaultChecked={
                                    data.Questionnaire4 == "d5" ? true : false
                                  }
                                  className="medium"
                                  type="radio"
                                  id="d5"
                                  name="d"
                                  value="d5"
                                />
                              </span>
                              <span style={{ margin: "2mm" }}>
                                Strongly Agree
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr style={{ width: "50%" }}>
              <td>
                <table style={{ width: "100%" }}>
                  <thead>
                    <tr>
                      <td style={{ width: "50%" }}>
                        <img
                          src={data.InterpretorSignature}
                          style={{
                            width: "30mm",
                            padding: "1em 0 0 0",
                            display: "block",
                          }}
                        />
                      </td>
                      <td style={{ width: "50%", textAlign: "right" }}>
                        <img
                          src={data.ClientSignature}
                          style={{
                            width: "30mm",
                            padding: "1em 0 0 0",
                            display: "block",
                            marginLeft: "auto",
                          }}
                        />
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ width: "50%" }}>
                        <hr
                          style={{
                            width: "70mm",
                            borderTop: "1px solid #ccc",
                            margin: "0.5em 0",
                          }}
                        />
                        Interpreter
                      </td>
                      <td style={{ width: "50%", textAlign: "right" }}>
                        <hr
                          style={{
                            width: "70mm",
                            borderTop: "1px solid #ccc",
                            margin: "0.5em 0",
                            marginLeft: "auto",
                          }}
                        />
                        Client or authorized representative
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr style={{ width: "100%" }}>
              <td style={{ textAlign: "center", padding: "2em 2em 0 2em" }}>
                Powered by
                <a
                  href="https://vrigateway.com/"
                  target="_blank"
                  style={{ margin: "0 0.3em" }}
                >
                  {ApplicationName}
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
